<template>
  <div class="currencies-comp">
    <a-auto-complete
      class="certain-category-search"
      size="large"
      style="width: 100%"
      placeholder="Add Currencies"
      optionLabelProp="value"
      @select="onSelect"
      @search="handleSearch"
    >
      <template slot="dataSource">
        <a-select-option v-for="item in dataSource" :key="item.code">
          <span slot="label">{{item.name}} ({{item.symbol}})</span>
        </a-select-option>
      </template>
      <a-input>
        <a-icon slot="prefix" type="search" class="certain-category-icon" />
      </a-input>
    </a-auto-complete>
    <br />
    <br />
    <a-table :columns="columns" :dataSource="selectedCurrencies" bordered>
      <span slot="isDefault" slot-scope="text, record">
        <a-checkbox :checked="record.checked" @change="setDefault(record, $event)"></a-checkbox>
      </span>
      <a
        slot="name"
        slot-scope="text, record"
        href="javascript:;"
      >{{record.name}}({{record.symbol}})</a>
      <span slot="action" slot-scope="text, record">
        <a-button @click="onDelete(record)" type="primary">{{$t('delete')}}</a-button>
      </span>
    </a-table>
  </div>
</template>

<script>
import { currencies } from "../configs.js";
import { mapState, mapActions } from "vuex";
import { CURRENCIES, USER_INFO } from "../store/constants";

export default {
  name: "Currencies",
  data() {
    return {
      value: "",
      processing: false,
      dataSource: JSON.parse(JSON.stringify(currencies)),
      columns: [
        {
          align: "center",
          width: 50,
          dataIndex: "isDefault",
          key: "isDefault",
          title: "Default Currency",
          scopedSlots: { customRender: "isDefault" }
        },
        {
          dataIndex: "name",
          key: "name",
          title: "Name",
          scopedSlots: { customRender: "name" }
        },
        {
          align: "center",
          width: 100,
          title: "Actions",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      selectedCurrencies: []
    };
  },
  computed: {
    ...mapState({
      currencies: state => state.currencies[CURRENCIES],
      user: state => state.auth[USER_INFO]
    })
  },
  watch: {
    currencies(newV, oldV) {
      this.selectedCurrencies = this.currencies.map(d => ({
        id: d.id,
        key: d.key,
        name: d.name,
        symbol: d.symbol,
        checked: this.user.defaultCurrency.key === d.key
      }));
    }
  },
  methods: {
    ...mapActions({
      getCurrencies: "currencies/getCurrencies",
      createCurrency: "currencies/createCurrency",
      deleteCurrency: "currencies/deleteCurrency",
      updateDefaultCurrency: "currencies/updateDefaultCurrency"
    }),
    setDefault(d, value) {
      this.selectedCurrencies = this.selectedCurrencies.map(item => {
        item.checked = item.key === d.key;
        return item;
      });
      const tmp = this.selectedCurrencies.filter(d => d.checked)[0];
      this.updateDefaultCurrency({
        key: tmp.key,
        symbol: tmp.symbol,
        name: tmp.name
      });
    },
    onDelete(d) {
      // this.selectedCurrencies = this.selectedCurrencies.filter(
      //   item => item.key !== d.key
      // );
      const tmp = this.selectedCurrencies.filter(d => d.checked)[0];
      this.deleteCurrency({
        id: d.id,
        defaultCurrency: { key: tmp.key, symbol: tmp.symbol, name: tmp.name }
      });
    },
    handleSearch(value) {
      this.dataSource = JSON.parse(JSON.stringify(currencies)).filter(d =>
        d.name.toLowerCase().includes(value)
      );
    },
    onSelect(value) {
      this.value = "";
      const temp = currencies.filter(d => d.code === value)[0];
      if (this.selectedCurrencies.length > 4) {
        return this.$notification.success({
          message: "You cannot add more than 5 currencies",
          placement: "bottomLeft"
        });
      } else if (
        this.selectedCurrencies.filter(d => d.key === temp.code).length
      ) {
        return this.$notification.success({
          message: "Currency already added",
          placement: "bottomLeft"
        });
      }

      this.selectedCurrencies.push({
        key: temp.code,
        symbol: temp.symbol,
        name: temp.name,
        checked: this.selectedCurrencies.length === 0
      });
      const tmp = this.selectedCurrencies.filter(d => d.checked)[0];
      this.createCurrency({
        defaultCurrency: { key: tmp.key, symbol: tmp.symbol, name: tmp.name },
        currencies: [
          {
            key: temp.code,
            symbol: temp.symbol,
            name: temp.name
          }
        ]
      });
    }
  },
  created() {
    this.getCurrencies()
      .then(() => (this.initLoading = false))
      .catch(() => (this.initLoading = false));
  }
};
</script>

<style scoped lang="less">
@import "../styles/variables.less";
.button-row {
  width: 100%;
  text-align: right;
  margin-top: @spacing*2;
}
.currencies-comp {
  margin-top: -32px;
  background: #f0f2f5;
  border: solid 1px #e8e8e8;
  padding: 16px;
  border-radius: 0px 16px 16px 16px;
}
</style>
